var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},_vm._l((_vm.tournaments),function(tournament,key){return _c('div',{key:key,staticClass:"col-12 col-md-6 p-2 px-sm-3 px-md-2"},[_c('TournamentCard',{attrs:{"tournament":tournament},nativeOn:{"click":function($event){return _vm.goToTournamnet(tournament.routeName)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }